export const PLAYABLE_TEAM_ABBREVIATIONS = [
  'ATL',
  'BUF',
  'CHI',
  'CIN',
  'CLE',
  'DAL',
  'DEN',
  'DET',
  'GB',
  'HOU',
  'IND',
  'KC',
  'LA',
  'MIA',
  'MIN',
  'NE',
  'NO',
  'NYG',
  'NYJ',
  'PHX',
  'PHI',
  'PIT',
  'RAI',
  'SD',
  'SEA',
  'SF',
  'TB',
  'WAS',
] as const

export type PlayableTeamAbbreviation = (typeof PLAYABLE_TEAM_ABBREVIATIONS)[number]

const PLAYABLE_TEAM_ALIAS_MAP: Record<string, PlayableTeamAbbreviation> = {
  JETS: 'NYJ',
  GIA: 'NYG',
  LAR: 'LA',
  RAMS: 'LA',
  STL: 'LA',
  LAC: 'SD',
  ARI: 'PHX',
  WSH: 'WAS',
  LVR: 'RAI',
}

/**
 * Normalizes historical or modern aliases to the playable Tecmo team labels.
 */
export function normalizePlayableTeamAbbreviation(team: string | null | undefined): PlayableTeamAbbreviation | null {
  if (!team) {
    return null
  }

  const normalized = team.toUpperCase()
  const mapped = PLAYABLE_TEAM_ALIAS_MAP[normalized] ?? normalized

  return PLAYABLE_TEAM_ABBREVIATIONS.includes(mapped as PlayableTeamAbbreviation)
    ? (mapped as PlayableTeamAbbreviation)
    : null
}

export const TEAM_HELMET_MAP: Record<string, string> = {
  BUF: 'bills',
  IND: 'colts',
  MIA: 'dolphins',
  NE: 'patriots',
  NYJ: 'jets',
  JETS: 'jets',
  CIN: 'bengals',
  CLE: 'browns',
  HOU: 'oilers',
  PIT: 'steelers',
  DEN: 'broncos',
  KC: 'chiefs',
  RAI: 'raiders',
  LVR: 'raiders',
  LAR: 'rams',
  RAMS: 'rams',
  SD: 'chargers',
  LAC: 'chargers',
  SEA: 'seahawks',
  WAS: 'redskins',
  WSH: 'redskins',
  NYG: 'giants',
  GIA: 'giants',
  PHI: 'eagles',
  PHX: 'cardinals',
  ARI: 'cardinals',
  DAL: 'cowboys',
  CHI: 'bears',
  DET: 'lions',
  GB: 'packers',
  MIN: 'vikings',
  TB: 'buccaneers',
  SF: '49ers',
  LA: 'rams',
  STL: 'rams',
  NO: 'saints',
  ATL: 'falcons',
  // Additional common aliases
  JAX: 'jaguars',
  CAR: 'panthers',
}

export function getHelmetSlug(abbreviation?: string | null): string | null {
  if (!abbreviation) return null
  const normalized = abbreviation.toUpperCase()
  return TEAM_HELMET_MAP[normalized] ?? null
}




